import { createFileRoute } from '@tanstack/react-router';
import { NewsletterSetupRouteView } from '@/pages/workspaces/broadcasts/newsletter/setup/routing';

function NewsletterSetupRoute() {
  const { newsletterId } = Route.useParams();
  return <NewsletterSetupRouteView newsletterId={newsletterId} />;
}

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/broadcasts_/newsletter/$newsletterId/setup',
)({
  component: NewsletterSetupRoute,
});
